import { render, staticRenderFns } from "./ContactNew.vue?vue&type=template&id=23db909a&scoped=true"
import script from "./ContactNew.vue?vue&type=script&lang=js"
export * from "./ContactNew.vue?vue&type=script&lang=js"
import style0 from "./ContactNew.vue?vue&type=style&index=0&id=23db909a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db909a",
  null
  
)

export default component.exports